import React, { useEffect, useState } from "react";
import { getProjectApi } from "../../api";
import config from "../../config";

const Contributors = () => {
    const [project, setProject] = useState({});
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchProject = async () => {
            try {
                setLoading(true);
                const result = await getProjectApi(config.project.id);
                if (result.status) {
                    setProject(result.data);
                }
            } catch (error) {
                console.error("Proje verisi yüklenirken hata:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchProject();
    }, []);

    if (loading) {
        return (
            <div className="page-content relative">
                <div className="text-center">Yükleniyor...</div>
            </div>
        );
    }

    return (
        <div className="page-content relative">
            {project.contributors ? (
                <div dangerouslySetInnerHTML={{ __html: project.contributors }} />
            ) : (
                <div>
                    <p>İçerik yüklenemedi.</p>
                </div>
            )}
        </div>
    );
};

export default Contributors;
